export class DocumentActionService {

  static async selectCitation(citationId: string) {
    if (
      window.Office &&
      window.Office.context &&
      window.Office.context.document &&
      window.Word &&
      window.Word.run
    ) {
      try {
        await window.Word.run(async (context: any) => {
          try {
            // citationId is a bookmark name (e.g. "ba_cite_0")
            const range = context.document.getBookmarkRangeOrNullObject(citationId);
            range.load("isNullObject");
            await context.sync();

            if (range.isNullObject) {
              console.warn("Bookmark not found:", citationId);
              return;
            }

            range.select();
            await context.sync();
          } catch (e) {
            console.error("Error scrolling to bookmark:", e);
            return;
          }
        });
      } catch (err) {
        console.error("Word.run bookmark select failed:", err);
      }
    }
  }
}
